<mat-toolbar class="background-color-green" style=" position: sticky; top: 0;  z-index: 7;">            
    <span class="text-color-white">{{ 'ml_144011' | translate }}</span>
    <span class="example-spacer"></span>        
    <a mat-dialog-close>
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="arrow_back" style="padding-top:9px; margin-right:10px; color:white;"></mat-icon>
    </a>     
</mat-toolbar>

<div *ngIf="isLoading" class="center">
    <mat-spinner  [color]="color"></mat-spinner>
</div>

<div *ngIf="showImg">    
    <img width="100%" height="auto" [src]="jpgSafeUrl()" alt="image" />
</div>



<div id="pdf-container" *ngIf="showPdf">
    <div #pdfViewer></div>
</div>